// Site Configuration - Golden Pour
export const siteConfig = {
  // Brand Information
  brand: {
    name: 'Golden Pour',
    tagline: 'POUR. RELAX. REPEAT.',
    companyName: 'Golden Pour Pty Ltd',
    description: "Melbourne's finest Victoria on tap. 12 rotating taps, local breweries, pure relaxation."
  },

  // Contact Information
  contact: {
    address: {
      street: '21 Centreway',
      suburb: 'Keilor East',
      state: 'VIC',
      postcode: '3033',
      country: 'Australia',
      full: '21 Centreway, Keilor East VIC 3033'
    },
    phone: null, // To be added when available
    email: null, // To be added when available
    website: 'https://goldenpour.com.au'
  },

  // Opening Hours
  hours: {
    status: 'opening_soon',
    message: 'Opening Soon',
    regular: {
      monday: { open: '15:00', close: '23:00', closed: false },
      tuesday: { open: '15:00', close: '23:00', closed: false },
      wednesday: { open: '15:00', close: '23:00', closed: false },
      thursday: { open: '15:00', close: '23:00', closed: false },
      friday: { open: '15:00', close: '01:00', closed: false },
      saturday: { open: '12:00', close: '01:00', closed: false },
      sunday: { open: '12:00', close: '22:00', closed: false }
    }
  },

  // Social Media
  social: {
    facebook: null,
    instagram: null,
    twitter: null
  },

  // Navigation Menu
  navigation: [
    { name: 'Home', path: '/', external: false },
    { name: 'Tap List', path: '/menu', external: false },
    { name: 'About', path: '/about', external: false },
    { name: 'Find Us', path: '#map', external: false }
  ],

  // Footer Menu
  footerMenu: [
    { name: 'Privacy Policy', path: '/privacy', external: false },
    { name: 'TV Mode', path: '/tv', external: false }
  ],

  // Key Features
  features: {
    tapsCount: 12,
    concept: 'BYO Food Welcome',
    focus: 'Local Victorian Breweries',
    atmosphere: 'Family Friendly'
  },

  // SEO & Meta
  meta: {
    title: 'Golden Pour - Premium Australian Bar',
    description: "Melbourne's finest Victoria on tap. 12 rotating taps, local breweries, pure relaxation. BYO food welcome.",
    keywords: ['bar', 'pub', 'beer', 'melbourne', 'keilor east', 'local breweries', 'craft beer', 'byo food'],
    author: 'Golden Pour Pty Ltd'
  }
};